import { useEffect, useState } from "react";
import { useAppContext } from "../../context/appContext";
import { ArtistResponseDTOMin } from "../../openapi-generated-client";
import { ArtistIdNamePair } from "../../pages/dashboard/edit-piece/steps/components/editPieceContributorElement";
import ArtistMinDisplay from "../artist/artistMinDisplay";
import TextField from "./textField";

interface TextFieldArtistSuggestionsProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    onEnter?: () => void;
    placeholder?: string;
    type?: string;
    className?: string;
    maxLength?: number;
    autoFocus?: boolean;
    artist?: ArtistIdNamePair;
    setArtist: (id: number, name: string) => void;
}

export default function TextFieldArtistSuggestions(props: TextFieldArtistSuggestionsProps) {

    const {artistController} = useAppContext();

    const [focus, setFocus] = useState(false);

    const [data, setData] = useState<ArtistResponseDTOMin[]>();

    async function fetchData() {
        setData((await artistController.findArtist({
            query: props.value,
        })).data);
    }

    useEffect(() => {
        fetchData();
    }, [props.value])

    return <TextField label={props.label}
        onFocus={setFocus}
        value={props.value}
        onChange={props.onChange}
        onEnter={props.onEnter}
        placeholder={props.placeholder}
        type={props.type}
        className={props.className + (props.artist && props.artist.id ? props.artist.id > 0 ? " red" : "" : "")}
        maxLength={props.maxLength}
        autoFocus={props.autoFocus}>
            <div className="artist-suggestions">
                {focus ? data?.map((artist, i) => {
                    if(i >= 5) return <></>; // Limit to 5 suggestions
                    return <ArtistMinDisplay artist={artist} url="/artist" onClick={() => {
                        props.setArtist(artist.id, artist.name);
                    }}/>
                }) : <></>
                }
            </div>
        </TextField>

}